import { Badge } from "@/components/ui/badge";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { GetRoomPhotosApi } from "@/features/private-room/photos/adapters/get-room-photos";
import {
  LoaderFunctionArgs,
  redirect,
  useLoaderData,
  useNavigate,
} from "react-router-dom";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  if (!params.roomId) throw redirect("/");

  try {
    const roomData = await GetRoomPhotosApi({ id: params.roomId });
    return { room: roomData };
  } catch (error) {
    console.error("Failed to load room photos:", error);
    throw redirect("/");
  }
};

type LoaderData = Awaited<ReturnType<typeof loader>>;

export const PhotosModal = () => {
  const { room } = useLoaderData() as LoaderData;
  const navigate = useNavigate();

  const photos = room.pictures;

  const handleClose = () => {
    navigate("/private-office/admin");
  };

  return (
    <Dialog open onOpenChange={handleClose}>
      <DialogContent className=" h-auto sm:max-w-[800px] p-0 overflow-hidden ">
        <DialogHeader className="p-6 mb-2 bg-background h-[50px]">
          <DialogTitle>
            <div className="flex items-center justify-between gap-4">
              <div className="flex gap-4 items-center">
                <p>Imagens</p>
                <div className="flex items-center justify-center border-2 border-gray-200 rounded-md p-2 h-6 w-6 text-sm">
                  {photos.length}
                </div>
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="w-full flex items-center justify-center  pb-10 ">
          <Carousel className="w-full px-4 mx-4">
            <CarouselContent>
              {photos.map((img, index) => (
                <CarouselItem key={index} className="">
                  <div className="flex items-center justify-center relative">
                    <Badge
                      className="absolute z-10 left-12 top-3"
                      variant="secondary"
                    >
                      Foto sala
                    </Badge>
                    <img
                      src={img}
                      alt={`Image ${index + 1}`}
                      className="max-w-[90%] object-contain rounded-lg"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="left-1" />
            <CarouselNext className="right-1" />
          </Carousel>
        </div>
      </DialogContent>
    </Dialog>
  );
};
